<script>
  import { _ } from "svelte-i18n"
  import { previews_search_filter } from "./../stores"

  function clear() {
    $previews_search_filter = ""
  }

</script>

<div>
  <input 
    bind:value={$previews_search_filter} 
    class:dirty={$previews_search_filter !== ""}
    placeholder="{$_('buttons.search')}"
    type="text" 
    >
  {#if $previews_search_filter !== ""}
    <span class="clear" on:click={clear}>&times;</span>
  {/if}
</div>

<style>
  div {
    position: relative;
    height: 4rem;
  }
  input {
    width: 9rem;
    border: 2px solid transparent;
    border-radius: 2.1rem;
    height: 4.2rem;
    background-color: transparent;
    color: var(--c-accent);
    padding: 0.4rem 1.2rem 0.6rem;
    margin: 0 -1rem;
    transition: all var(--transition-props);
    font-family: var(--PensumSans);
    font-size: 2.2rem;
  }

  input:focus,
  input.dirty {
    width: 20rem;
  }

  input:hover,
  input:focus {
    border-color: var(--c-text);
  }
  input.dirty {
    border-color: var(--c-accent);
  }
  
  input::placeholder {
    color: var(--c-text-faded);
    transition: color var(--transition-props);
  }
  
  .clear {
    display: inline-block;
    position: absolute;
    right: -1rem;
    top: 0;
    width: 3rem;
    padding-right: 2rem;
    font-size: 2.6rem;
    font-family: var(--Lucida);
    color: var(--c-text-faded);
    cursor: pointer;
    transition: color var(--transition-props);
  }
  .clear:hover {
    color: var(--c-text);
  }
</style>